































































































//@ts-nocheck
//@ts-ignore
import { Component, Vue } from 'vue-property-decorator';


//@ts-ignore
import { email, required } from 'vuelidate/lib/validators';
//@ts-ignore

import Notiflix from "notiflix";
import { Row } from 'jspdf-autotable';
//import {Vuetable,VuetablePagination} from 'vuetable-2'


@Component({
  components: {
   /*
    Vuetable,
    VuetablePagination,*/
  
    

  },
  data() {
    return {
        //idmunicipio,nombre, fecha_alta, 
     
              
      
    }
  },
     mixins: [],
     

   
 
  methods:{
      click(){
          console.log('Log', this.$store.state.user.municipio)
      }
  },
  mounted(){
         //alert('10')
  }
})
export default class Home extends Vue {}

